import { createTheme } from '@mui/material/styles';

const theme = (mode, direction) =>
  createTheme({
    direction: direction,
    palette: {
      mode: mode,
      primary: {
        main: '#c41c1c',
        light: '#e33e3e',
        dark: '#8c1414',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#333333',
        light: '#555555',
        dark: '#222222',
        contrastText: '#ffffff',
      },
      background: {
        default: '#ffffff',
        paper: '#f5f5f5',
        dark: '#1a1a1a',
        // dark: '#5F5D63',
      },
      text: {
        primary: '#333333',
        secondary: '#666666',
        disabled: '#999999',
        hint: '#999999',
      },
      action: {
        active: 'rgba(0, 0, 0, 0.54)',
        hover: 'rgba(0, 0, 0, 0.04)',
        selected: 'rgba(0, 0, 0, 0.08)',
        disabled: 'rgba(0, 0, 0, 0.26)',
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
      },
      divider: 'rgba(0, 0, 0, 0.12)',
    },
    typography: {
      fontFamily:
        direction === 'rtl'
          ? '"Cairo", "Poppins", "Roboto", "Arial", sans-serif'
          : '"Poppins", "Roboto", "Arial", sans-serif',
      h1: {
        fontWeight: 700,
        fontSize: direction === 'rtl' ? '4rem' : '3rem',
        lineHeight: 1.2,
        '@media (max-width:600px)': {
          fontSize: direction === 'rtl' ? '3.5rem' : '2.5rem',
        },
      },
      h2: {
        fontWeight: 700,
        fontSize: direction === 'rtl' ? '3.5rem' : '2.5rem',
        lineHeight: 1.3,
        '@media (max-width:600px)': {
          fontSize: direction === 'rtl' ? '3rem' : '2rem',
        },
      },
      h3: {
        fontWeight: 600,
        fontSize: direction === 'rtl' ? '2.75rem' : '2rem',
        lineHeight: 1.4,
        '@media (max-width:600px)': {
          fontSize: direction === 'rtl' ? '2.25rem' : '1.75rem',
        },
      },
      h4: {
        fontWeight: 600,
        fontSize: direction === 'rtl' ? '2rem' : '1.5rem',
        lineHeight: 1.4,
        '@media (max-width:600px)': {
          fontSize: direction === 'rtl' ? '1.75rem' : '1.25rem',
        },
      },
      h5: {
        fontWeight: 500,
        fontSize: direction === 'rtl' ? '1.5rem' : '1.25rem',
        lineHeight: 1.5,
      },
      h6: {
        fontWeight: 500,
        fontSize: direction === 'rtl' ? '1.25rem' : '1rem',
        lineHeight: 1.6,
      },
      body1: {
        fontSize: direction === 'rtl' ? '1.25rem' : '1rem',
        lineHeight: 1.6,
      },
      body2: {
        fontSize: direction === 'rtl' ? '1.125rem' : '0.875rem',
        lineHeight: 1.6,
      },
      button: {
        fontWeight: 500,
        fontSize: '0.875rem',
        textTransform: 'none',
      },
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableRipple: true,
        },
        styleOverrides: {
          root: {
            borderRadius: 8,
            padding: '8px 24px',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          },
          contained: {
            '&:hover': {
              boxShadow: 'none',
            },
          },
          text: {
            '& .MuiTouchRipple-root': {
              display: 'none',
            },
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: 'rgba(0, 0, 0, 0.12)',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ccc',
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ccc',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#999',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#c41c1c',
              borderWidth: '2px',
            },
          },
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });

export default theme;
